<div class="invoice-body template-4">
  <div class="row" style="padding-bottom: 30px">
    <div class="col-md-6">
      <div class="account-details left" *ngIf="locationData">
        <h2>{{ businessInfo.BusinessName}}</h2>
        <p>
          {{ businessInfo.Address1 }}, {{ businessInfo.City }},
          {{businessInfo.StateId}} {{ businessInfo.PostalCode
          }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode : ''}}
        </p>
        <p>{{ businessInfo.ContactNumber }}</p>
        <p style="display: none">
          Location : {{locationData ? locationData.BranchName : ''}}
        </p>
      </div>
    </div>
    <div
      class="logo logo-left col-md-6 pr-0"
      [style.background-image]="sanitizer.bypassSecurityTrustStyle('url(' + businessInfo.Logo + ')')"
      style="
        background-repeat: no-repeat;
        background-position: right center;
        background-size: contain;
      "
    ></div>
  </div>

  <div class="row" style="padding: 50px 0 60px">
    <div class="col-md-6">
      <div class="customer-details">
        <h2 *ngIf="customerInfo.CustomerTypeId == 1">
          {{ customerInfo.FirstName }} {{ customerInfo.LastName }}
        </h2>
        <h2 *ngIf="customerInfo.CustomerTypeId == 2">
          {{ customerInfo.BusinessName }}
        </h2>
        <p>{{ customerAddress }}</p>
        <p>{{ customerInfo.EmailAddress }}</p>
      </div>
    </div>
    <div class="col-md-6 amount-due">
      <h3>Amount to pay</h3>
      <h4>Pay on or before {{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</h4>
      <h2 class="currency-item flex items-center justify-center gap-2">
        {{ !["Partial", "Paid"].includes(manualInvoice.Status) ?
        (totalInvoiceAmount | currency) : (manualInvoice.AmountDue | currency)
        }}
        <div style="display: inline-block">
          <div
            class="tag-pill uppercase"
            [class]="'tag-'+ manualInvoice?.Status.toLocaleLowerCase() || 'paid' "
          >
            {{ manualInvoice.Status || 'Paid' }}
          </div>
        </div>
      </h2>
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-md-12 px-0">
      <div class="panel-group" id="template4-accordion">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h4 class="panel-title">
              <a
                data-toggle="collapse"
                data-parent="#template4-accordion"
                href="#collapse1"
              >
                Invoice # {{ manualInvoice.InvoiceNumber ?
                manualInvoice.InvoiceNumber : '000-000-0000' }}
                <span>Page 1 of 2</span>
              </a>
            </h4>
          </div>
          <div id="collapse1" class="panel-collapse collapse in show">
            <div class="panel-body">
              <div class="row info-detail mt-1 mb-3">
                <div class="col-md-4 pr-0">
                  <div class="detail">
                    <p>Location</p>
                    <span>{{locationData ? locationData.BranchName : ''}}</span>
                  </div>
                </div>

                <div class="col-md-4 px-1">
                  <div class="detail">
                    <p>Invoice Date</p>
                    <span
                      >{{ manualInvoice.InvoiceDate | date:'MM/dd/yyyy'}}</span
                    >
                  </div>
                </div>

                <div class="col-md-4 pl-0">
                  <div class="detail">
                    <p>Due Date</p>
                    <span>{{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>
              </div>

              <div
                class="row info-detail mt-1 mb-3"
                *ngFor="let item of manualInvoicePayments"
              >
                <div class="col-md-4 pr-0">
                  <div class="detail">
                    <p>Transaction ID</p>
                    <span>{{item.transactionId}}</span>
                  </div>
                </div>

                <div class="col-md-4 px-1">
                  <div class="detail">
                    <p>Payment Date</p>
                    <span>{{item.date | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>

                <div class="col-md-4 pl-0">
                  <div class="detail">
                    <p>Payment Method</p>
                    <span>{{item?.paymentMethodTypeName || '-none-'}}</span>
                  </div>
                </div>
              </div>

              <div class="row info-item">
                <div class="col-md-12">
                  <table class="invoice-table2">
                    <thead>
                      <tr>
                        <th>Item/Service</th>
                        <th>Unit Cost</th>
                        <th>Quantity</th>
                        <th class="text-right">Line Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of invoiceItems">
                        <td
                          [class.with-description]="item.ServiceDescription || getL2L3Description(item)"
                        >
                          {{ item.ItemName }}
                          <div class="item-description">
                            <div *ngIf="item.ServiceDescription">
                              {{ item.ServiceDescription }}
                            </div>

                            <ng-container *ngIf="getL2L3Description(item)">
                              <br />
                              <div class="l2l3-description">
                                <span *ngIf="item.TaxAmount"
                                  >Tax Amount: {{ item.TaxAmount }}</span
                                >
                                <span *ngIf="item.TaxType"
                                  >Tax Indicator: {{ item.TaxType }}</span
                                >
                                <span *ngIf="item.ProductCode"
                                  >Purchase ID: {{ item.ProductCode }}</span
                                >
                                <span *ngIf="item.ItemCommodityCode"
                                  >Commodity Code: {{ item.ItemCommodityCode
                                  }}</span
                                >
                                <span *ngIf="item.UnitOfMeasure"
                                  >Unit of Measure: {{ item.UnitOfMeasure
                                  }}</span
                                >
                                <span *ngIf="item.DiscountAmount"
                                  >Discount: {{ item.DiscountAmount }}</span
                                >
                                <span *ngIf="item.TaxTreatment"
                                  >Tax Treatment: {{ item.TaxTreatment }}</span
                                >
                              </div>
                            </ng-container>
                          </div>
                        </td>
                        <td>
                          $ {{ item.Rate ? item.Rate.toFixed(2) : '0.00' }}
                        </td>
                        <td>{{ item.Quantity }}</td>
                        <td class="text-right">
                          $ {{ item.Amount ? item.Amount.toFixed(2) : '0.00' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row info-others px-3">
                <div class="col-md-6 additional">
                  <h6>Additional information about your invoice</h6>

                  <div style="margin-top: 8px">
                    <div
                      *ngFor="let field of customFieldValues;let i = index;"
                      class="form-group"
                    >
                      <label style="flex: unset; width: 120px"
                        >{{field.fieldName}}</label
                      >
                      <p style="flex: unset">
                        <ng-container *ngIf="field.fieldDataType !== 104">
                          {{ field.fieldValue }}
                        </ng-container>

                        <ng-container *ngIf="field.fieldDataType === 104">
                          <!-- <cj-checkbox
                            id="customFieldId{{i}}"
                            name="customfield[{{ i }}]"
                            style="pointer-events: none;"
                            size="small"
                            disabled="true"
                            [ngModel]="field.fieldValue"
                          ></cj-checkbox> -->
                          {{ field.fieldValue && field.fieldValue === 'true' ?
                          'Yes' : 'No' }}
                        </ng-container>
                      </p>
                    </div>
                  </div>

                  <div class="form-group" *ngIf="manualInvoice.Notes">
                    <label style="flex: unset; width: 120px">Notes</label>
                    <p style="flex: unset">{{ manualInvoice.Notes }}</p>
                  </div>
                </div>

                <div class="col-md-6 pr-0 pl-4">
                  <div class="initial-total">
                    <div class="form-group" *ngIf="false">
                      <label>Line total</label>
                      <p>
                        $ {{ manualInvoice.TotalAmount ?
                        manualInvoice.TotalAmount.toFixed(2) : '0.00' }}
                      </p>
                    </div>
                    <div class="form-group">
                      <label>Gross Total</label>
                      <p>$ {{ grossTotal ? grossTotal.toFixed(2) : '0.00' }}</p>
                    </div>
                    <div class="form-group">
                      <label>
                        Partial Amount
                        <!-- <span>(Previous Payment)</span> -->
                      </label>
                      <p *ngIf="partialPayment">
                        {{ partialPayment.partialDueType === 'USD' ? '$' : '%'
                        }} {{ partialPayment.partialDue ?
                        partialPayment.partialDue.toFixed(2) : '0.00' }}
                      </p>
                      <p *ngIf="!partialPayment">-</p>
                    </div>
                  </div>

                  <div class="adjustments">
                    <div class="form-group">
                      <label>Adjustments</label>
                      <p></p>
                    </div>

                    <div class="form-group">
                      <label>Discount</label>
                      <p>
                        {{ manualInvoice.DiscountType }} {{
                        manualInvoice.Discount ?
                        manualInvoice.Discount.toFixed(2) : '0.00' }}
                      </p>
                    </div>
                    <div class="form-group" *ngIf="displayTipAmt">
                      <label>Tip</label>
                      <p>{{ manualInvoice.TipType }} {{ tipAmt.toFixed(2) }}</p>
                    </div>
                    <div class="form-group">
                      <label>
                        {{ manualInvoice.UpchargeName === 'Custom upcharge' ?
                        'Upcharge' : manualInvoice.UpchargeName }}
                      </label>
                      <p>
                        {{ manualInvoice.UpchargeType }} {{
                        manualInvoice.Upcharge ?
                        manualInvoice.Upcharge.toFixed(2) : '0.00' }}
                      </p>
                    </div>
                    <div class="form-group">
                      <label>Tax</label>
                      <p>
                        {{ manualInvoice.TaxType }} {{ manualInvoice.Tax ?
                        manualInvoice.Tax.toFixed(2) : '0.00' }}
                      </p>
                    </div>
                    <div
                      class="form-group"
                      *ngIf="manualInvoice.Tax && manualInvoice.TaxableTotal"
                    >
                      <label>Taxable Total</label>
                      <p>
                        $ {{ manualInvoice.TaxableTotal ?
                        manualInvoice.TaxableTotal.toFixed(2) : '0.00' }}
                      </p>
                    </div>
                    <div
                      class="form-group"
                      *ngIf="manualInvoice.Tax && manualInvoice.NonTaxableTotal"
                    >
                      <label>Non-taxable Total</label>
                      <p>
                        $ {{ manualInvoice.NonTaxableTotal ?
                        manualInvoice.NonTaxableTotal.toFixed(2) : '0.00' }}
                      </p>
                    </div>
                  </div>

                  <div class="actual-total">
                    <div class="form-group">
                      <label>Invoice Amount</label>
                      <p>
                        $ {{ totalInvoiceAmount ? totalInvoiceAmount.toFixed(2)
                        : '0.00' }}
                      </p>
                    </div>

                    <div
                      class="form-group"
                      *ngIf="!partialPayment; else amountPartial"
                    >
                      <label>
                        <h3><strong>Amount due</strong></h3>
                      </label>
                      <p class="amount">
                        $ {{ manualInvoice.Balance && manualInvoice.Status !==
                        'Paid' ? manualInvoice.Balance.toFixed(2) : '0.00' }}
                      </p>
                    </div>

                    <ng-template #amountPartial>
                      <div class="form-group">
                        <label>Partial Amount Due</label>
                        <p class="currency-item amount">
                          {{ !["Partial", "Paid"].includes(manualInvoice.Status)
                          ? (getPartialAmountDue() | currency) : (0 | currency)
                          }}
                        </p>
                      </div>
                      <div class="form-group">
                        <label>
                          <h3><strong>Total Amount Due</strong></h3>
                        </label>
                        <p class="currency-item amount">
                          {{ !["Partial", "Paid"].includes(manualInvoice.Status)
                          ? (totalInvoiceAmount | currency) :
                          (manualInvoice.AmountDue | currency) }}
                        </p>
                      </div>
                    </ng-template>

                    <small>
                      <i>
                        Due Date {{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}
                      </i>
                    </small>
                  </div>
                </div>
              </div>

              <div class="row payment-instruction">
                <div
                  class="qr-code col-md-2 px-0"
                  [style.background-image]="backgroundImg"
                  style="
                    background-repeat: no-repeat;
                    background-position: left center;
                    background-size: contain;
                  "
                ></div>
                <div class="col-md-10 pr-0">
                  <h6>Payment instruction</h6>
                  <p>Please proceed to the payment website.</p>

                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="detail">
                        <p>Invoice #</p>
                        <span
                          >{{ manualInvoice.InvoiceNumber ?
                          manualInvoice.InvoiceNumber : '000-000-0000' }}</span
                        >
                      </div>
                    </div>

                    <div class="col-md-6 pl-1">
                      <div class="detail">
                        <p>Amount Due</p>
                        <span class="currency-item">
                          {{ !["Partial", "Paid"].includes(manualInvoice.Status)
                          ? (totalInvoiceAmount | currency) :
                          (manualInvoice.AmountDue | currency) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row payment-note">
                <div class="col-md-12">
                  <i
                    >For any concerns, kindly contact us thru email at
                    {{businessInfo.Email}} or you may call us
                    {{businessInfo.ContactNumber}}</i
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagebreak"></div>
        <!-- page break inserted here -->
        <div style="height: 50px; display: block; width: 100%">&nbsp;</div>
        <div class="panel panel-default">
          <div class="panel-heading">
            <h4 class="panel-title">
              <a
                data-toggle="collapse"
                data-parent="#template4-accordion"
                href="#collapse2"
              >
                Terms and Conditions: <span>Page 2 of 2</span>
              </a>
            </h4>
          </div>
          <div id="collapse2" class="panel-collapse collapse show">
            <div class="panel-body">
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="terms-condition">
                    <div
                      *ngFor="let tcp of tcps"
                      [innerHTML]="tcp.Content"
                      class="tcp-container"
                    ></div>
                  </div>
                </div>
              </div>

              <div class="row terms-condition-note mx-0 my-3" *ngIf="false">
                <div
                  class="col-md-2"
                  [style.background-image]="backgroundImg"
                  style="
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                  "
                ></div>
                <div class="col-md-10">
                  <i
                    >For any concerns, kindly contact us thru email at
                    {{businessInfo.Email}} or you may call us
                    {{businessInfo.ContactNumber}}</i
                  >
                </div>
              </div>
              <div class="row terms-condition-note mx-0 my-3">
                <div class="col-md-12">
                  <i>
                    <strong>RECEIPT</strong><br />
                    A receipt can be printed after payment is accepted which may
                    serve as evidence of payment. If an email address is
                    provided during the payment process, a receipt will be
                    emailed to you after the payment is processed.
                  </i>
                </div>
              </div>
              <div class="row terms-condition-note mx-0 my-3">
                <div class="col-md-12">
                  <i>
                    <strong>CONTACT</strong><br />
                    If for any reason you wish to make a change to the payment
                    after submission, please contact {{
                    businessInfo?.BusinessName }}, {{
                    businessInfo?.ContactNumber }} for assistance.
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
